import { render } from "./InstagramIcon.vue?vue&type=template&id=3b08e0fa"
import script from "./InstagramIcon.vue?vue&type=script&lang=js"
export * from "./InstagramIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__